/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  PutApiV1SerievideoVideoidLangsIdMutationRequest,
  PutApiV1SerievideoVideoidLangsIdMutationResponse,
  PutApiV1SerievideoVideoidLangsIdPathParams,
  PutApiV1SerievideoVideoidLangsIdQueryParams,
  PutApiV1SerievideoVideoidLangsId400,
  PutApiV1SerievideoVideoidLangsId401,
  PutApiV1SerievideoVideoidLangsId404,
  PutApiV1SerievideoVideoidLangsId500,
} from "../../types/serieVideoIdiomasController/PutApiV1SerievideoVideoidLangsId.ts";

function getPutApiV1SerievideoVideoidLangsIdUrl(
  videoId: PutApiV1SerievideoVideoidLangsIdPathParams["videoId"],
  id: PutApiV1SerievideoVideoidLangsIdPathParams["id"],
) {
  const res = {
    method: "PUT",
    url: `/api/v1/serievideo/${videoId}/langs/${id}` as const,
  };
  return res;
}

/**
 * @description Atualiza os textos de uma tradução (idioma) do vídeo. **(Requer Authorization para autenticação)**
 * @summary Atualizar idioma do vídeo (Requer Authorization para autenticação)
 * {@link /api/v1/serievideo/:videoId/langs/:id}
 */
export async function putApiV1SerievideoVideoidLangsId(
  videoId: PutApiV1SerievideoVideoidLangsIdPathParams["videoId"],
  id: PutApiV1SerievideoVideoidLangsIdPathParams["id"],
  data?: PutApiV1SerievideoVideoidLangsIdMutationRequest,
  params?: PutApiV1SerievideoVideoidLangsIdQueryParams,
  config: Partial<
    RequestConfig<PutApiV1SerievideoVideoidLangsIdMutationRequest>
  > & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const requestData = data;

  const res = await request<
    PutApiV1SerievideoVideoidLangsIdMutationResponse,
    ResponseErrorConfig<
      | PutApiV1SerievideoVideoidLangsId400
      | PutApiV1SerievideoVideoidLangsId401
      | PutApiV1SerievideoVideoidLangsId404
      | PutApiV1SerievideoVideoidLangsId500
    >,
    PutApiV1SerievideoVideoidLangsIdMutationRequest
  >({
    method: "PUT",
    url: getPutApiV1SerievideoVideoidLangsIdUrl(videoId, id).url.toString(),
    params,
    data: requestData,
    ...requestConfig,
    headers: { "Content-Type": "application/*+json", ...requestConfig.headers },
  });
  return res.data;
}
